import { gql } from '@apollo/client';
import { PROGRAMME } from '../fragments';

export const FILTERED_ADMIN_PROGRAMMES = gql`
  query FilteredAdminProgrammes($input: FilterProgrammes!) {
    programmes: filteredAdminProgrammes(input: $input) {
      ...programme
      serviceProviders {
        id
      }
      interventions {
        id
        name
      }
      funder {
        id
        name
      }
    }
  }
  ${PROGRAMME}
`;
